/** @jsxFrag React.Fragment */

/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import GrowthDiscoveryExperiments from 'bundles/epic/clients/GrowthDiscovery';
import { RegionalPromotionFullWidthBanner } from 'bundles/front-page/components/banners/regional-promotion-banner/RegionalPromotionFullWidthBanner';
import ReactPriceDisplay from 'bundles/payments-common/components/ReactPriceDisplay';

import _t from 'i18n!nls/front-page';

const styles = {
  link: css`
    text-decoration: underline;
  `,
};

type Props = {
  variant?: 'blue' | 'purple' | 'light-blue';
};

const RegionalPromotionBanner = ({ variant }: Props) => {
  const getBannerContent = () => {
    if (GrowthDiscoveryExperiments.get('regional2024NYPromotionsGlobal')) {
      return (
        <Typography2 component="p" variant="subtitleLarge">
          <FormattedHTMLMessage
            message={_t(
              `New year. Big goals. Bigger savings. Unlock a year of unlimited access to learning with Coursera Plus for {price}. {claim}`
            )}
            price={<ReactPriceDisplay value={199} currency="USD" hideCurrencyCode />}
            claim={
              <a css={styles.link} href="/courseraplus/special/global-new-year-2025-199">
                {_t(`Save now.`)}
              </a>
            }
          />
        </Typography2>
      );
    }
    if (GrowthDiscoveryExperiments.get('regional2024NYPromotionsGermany')) {
      return (
        <Typography2 component="p" variant="subtitleLarge">
          <FormattedHTMLMessage
            message={_t(
              `New year. Big goals. Bigger savings. Unlock a year of unlimited access to learning with Coursera Plus for {price}. {claim}`
            )}
            price={<ReactPriceDisplay value={184} currency="EUR" />}
            claim={
              <a css={styles.link} href="/courseraplus/special/new-year-de">
                {_t(`Save now.`)}
              </a>
            }
          />
        </Typography2>
      );
    }

    if (GrowthDiscoveryExperiments.get('regional2024NYPromotionsFrance')) {
      return (
        <Typography2 component="p" variant="subtitleLarge">
          <FormattedHTMLMessage
            message={_t(
              `New year. Big goals. Bigger savings. Unlock a year of unlimited access to learning with Coursera Plus for {price}. {claim}`
            )}
            price={<ReactPriceDisplay value={184} currency="EUR" />}
            claim={
              <a css={styles.link} href="/courseraplus/special/new-year-fr">
                {_t(`Save now.`)}
              </a>
            }
          />
        </Typography2>
      );
    }

    if (GrowthDiscoveryExperiments.get('regional2024NYPromotionsIndia')) {
      return (
        <Typography2 component="p" variant="subtitleLarge">
          <FormattedHTMLMessage
            message={_t(
              `New year. Big goals. Bigger savings. Unlock a year of unlimited access to learning with Coursera Plus for {price}. {claim}`
            )}
            price={<ReactPriceDisplay value={7499} currency="INR" />}
            claim={
              <a css={styles.link} href="/courseraplus/special/new-year-in">
                {_t(`Save now.`)}
              </a>
            }
          />
        </Typography2>
      );
    }

    if (GrowthDiscoveryExperiments.get('regional2024NYPromotionsEmerging')) {
      return (
        <Typography2 component="p" variant="subtitleLarge">
          <FormattedHTMLMessage
            message={_t(
              `New year. Big goals. Bigger savings. Unlock a year of unlimited access to learning with 65% off Coursera Plus. {claim}`
            )}
            claim={
              <a css={styles.link} href="/courseraplus/special/em">
                {_t(`Save now.`)}
              </a>
            }
          />
        </Typography2>
      );
    }

    if (GrowthDiscoveryExperiments.get('regional2024NYPromotionsLatam')) {
      return (
        <Typography2 component="p" variant="subtitleLarge">
          <FormattedHTMLMessage
            message={_t(
              `New year. Big goals. Bigger savings. Unlock a year of unlimited access to learning with 65% off Coursera Plus. {claim}`
            )}
            claim={
              <a css={styles.link} href="/courseraplus/special/new-year-latam">
                {_t(`Save now.`)}
              </a>
            }
          />
        </Typography2>
      );
    }
    return null;
  };

  const bannerContent = getBannerContent();

  if (!bannerContent) {
    return null;
  }

  // This div wrapper is required.
  // This wrapper prevents some sort of hydration related bug which leaks into the hero section below.
  return (
    <div>
      <RegionalPromotionFullWidthBanner variant={variant}>{getBannerContent()}</RegionalPromotionFullWidthBanner>
    </div>
  );
};

export { RegionalPromotionBanner };

export default RegionalPromotionBanner;
